import styled from 'styled-components'

export interface SemiCircleBackgroundProps {
    height: string
}

export const SemiCircleBackground = styled.div<SemiCircleBackgroundProps>`
    position: absolute;
    bottom: 0;
    background-color: ${(p) => p.theme.colors.primary.green100};
    width: 100%; /* Full width of the container */
    height: ${(p) => p.height};
    border-top-left-radius: 100% 35%;
    border-top-right-radius: 100% 35%;
    z-index: -1; /* Place the background behind the content */
`
